import { render, staticRenderFns } from "./spareRequirementsList.vue?vue&type=template&id=5159f760&scoped=true"
import script from "./spareRequirementsList.vue?vue&type=script&lang=js"
export * from "./spareRequirementsList.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsList.vue?vue&type=style&index=0&id=5159f760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159f760",
  null
  
)

export default component.exports